/**
 * SOA 10 PRO — píldora de estado (radio 999, Figtree 800, 12.5-13.5px).
 * v8.5.40 · F1 · Piel Estudio — antes pill mono uppercase con borde de 1px. Sigue resolviendo los 4 tokens semánticos +
 * neutral vía CSS vars, ahora con su borde "-line" a juego en vez de ring.
 */
import { IconoDe } from "./Icon.jsx";

const STYLE = {
  "solicitado":      "bg-[var(--canvas)] text-[var(--ink-3)] border-[var(--line)]",
  "en-proceso":      "bg-[var(--accent-soft)] text-[var(--accent)] border-[var(--accent)]/25",
  "listo-revisar":   "bg-[var(--accent-soft)] text-[var(--accent-ink)] border-[var(--accent-line)]",
  "cambios-pedidos": "bg-[var(--danger-soft)] text-[var(--danger)] border-[var(--danger-line)]",
  "aprobado":        "bg-[var(--done-soft)] text-[var(--done)] border-[var(--done-line)]",
  "publicado":       "bg-[var(--done-soft)] text-[var(--done)] border-[var(--done-line)]",
};

// v8.5.34 · F2 · Pieza.jsx unifica 4 vocabularios de estado, pero algunas
// pantallas (feed) traen su propio texto de estado en vez de una de las
// claves de arriba (ej. "En producción" desde FeedPreview). `tone` permite
// pedir el tratamiento visual correcto sin forzar esas pantallas a mapear
// su texto a una clave que no les pertenece.
const TONE_STYLE = {
  warning: "bg-[var(--attention-soft)] text-[var(--attention-ink)] border-[var(--attention-line)]",
  danger:  "bg-[var(--danger-soft)] text-[var(--danger)] border-[var(--danger-line)]",
  success: "bg-[var(--done-soft)] text-[var(--done)] border-[var(--done-line)]",
};

export default function EstadoBadge({ estado, label, icon, large, tone }) {
  const cls = tone ? TONE_STYLE[tone] : (STYLE[estado] || "bg-[var(--canvas)] text-[var(--ink-3)] border-[var(--line)]");
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border font-sans font-extrabold ${cls} ${large ? "px-4 py-2 text-[13.5px]" : "px-3 py-[5px] text-[12.5px]"}`}>
      {icon && <IconoDe valor={icon} size={16}/>}
      {label}
    </span>
  );
}
